import React, {Fragment, useContext, useEffect, useRef, useState} from "react";
import {useHistory, useParams} from 'react-router-dom'
import Card from "../../components/Card";
import {LoaderContext} from "../../context/LoaderContext";
import ModalMsg from "../../components/ModalMsg";
import {Field, Form, Formik} from "formik";
import LabelErroreCampo from "../../components/LabelErroreCampo";
import NsBtnBack from "../../components/buttons/NsBtnBack";
import {
    TIPO_CERTIFICATO_ALBO_E_CRS_IN_CIRCOLAZIONE,
    TIPO_REQ_VEICOLO_CRS,
    TIPO_REQ_VEICOLO_CRS_REIM,
    TIPO_REQ_VEICOLO_CRS_REIMM_ALBO
} from "../../utility/common";
import {RuoliContext} from "../../context/RuoliContext";
import {aggiornaPrivacyCertificatoApi, getCertificatoByIdApi} from "../../services/CertificatiServices";

export default function DichiarazionePrivacy() {
    const {idUsr, idCertificato} = useParams()

    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [certificato, setCertificato] = useState();

    const {startChiamata, endChiamata} = useContext(LoaderContext);
    const {isRuoloAdmin, isRuoloSegreteria} = useContext(RuoliContext);

    const history = useHistory();
    const formikRef = useRef();

    async function getCertificato() {
        startChiamata();

        const response = await getCertificatoByIdApi(idCertificato);
        setCertificato(response.data.data);
        if (formikRef.current) {
            formikRef.current.setFieldValue("privacy_cert", response.data.data.privacy_cert || '');
        }
        endChiamata();
    }

    useEffect(() => {
        if (idCertificato && idCertificato !== '') {
            getCertificato()
        }
    }, [idCertificato]);

    function procediCert() {
        if (certificato) {
            let tipoRichiesta = certificato.id_tipo_certificato;
            if (tipoRichiesta && (tipoRichiesta == TIPO_REQ_VEICOLO_CRS
                || tipoRichiesta == TIPO_REQ_VEICOLO_CRS_REIM
                || tipoRichiesta == TIPO_REQ_VEICOLO_CRS_REIMM_ALBO
                || tipoRichiesta == TIPO_CERTIFICATO_ALBO_E_CRS_IN_CIRCOLAZIONE)) {
                history.push(`/dich-resp-crs/${idUsr}/${idCertificato}`);
            } else {
                history.push(`/doc-aggiuntivi-cert/${idUsr}/${idCertificato}`);
            }
        }
    }

    async function aggiornaPrivacyCertificato(values) {
        startChiamata();

        const response = await aggiornaPrivacyCertificatoApi(idCertificato, values);
        endChiamata();
        if (response.data.result !== 0) {
            setModalMsg(response.data.description);
            setShow(true);
        } else {
            procediCert();
        }
    }

    return (
        <Card
            icon={'fas fa-check'}
            title={"INFORMATIVA sulla raccolta ed il trattamento dei DATI PERSONALI"}
            subtitle={"ai sensi dell'art. 13, D. Lgs. 30/06/2003, n° 196"}
            getBottoniDx={() =>
                <Fragment>
                    <NsBtnBack/>
                    <button
                        type="button"
                        id="salva"
                        name="salva"
                        className="btn btn-card"
                        onClick={() => {
                            if (formikRef.current) {
                                formikRef.current.handleSubmit()
                            }
                        }}>
                        <i className="fas fa-save"/> Salva e procedi
                    </button>
                </Fragment>
            }>
            <ModalMsg
                show={show}
                handleClose={() => setShow(false)}
                testo={modalMsg}/>
            <div className={"row mb-4"}>
                <div className={"col-md-12"}>
                    <p>
                        Ai sensi e per gli effetti del D. Lgs. 196/2003 "Testo Unico in materia di protezione dei dati
                        personali", il sottoscritto Edoardo Magnone, nella sua qualità del Presidente del Registro Fiat
                        Italiano con sede in Torino - Via C. Battisti, 2 con la presente
                    </p>
                    <h6>RENDE NOTO</h6>
                    <p>che ai fini della seguente informativa si intende:</p>
                    <ol type={"i"}>
                        <li>per interessato il sig. <i>{certificato && `${certificato.cognome} ${certificato.nome}`}</i>
                        </li>
                        <li>per il titolare il Registro Fiat Italiano - Via Cesare Battisti, 2 - 10123 Torino</li>
                    </ol>
                    <ol type={"a"}>
                        <li>che al fine di ottemperare agli adempimenti necessari al completamento della sua richiesta
                            di Certificato di rilevanza storica e collezionistica, il titolare effettuerà in modo
                            automatizzato e non automatizzato il trattamento di dati personali che la riguardano;
                        </li>
                        <li>che il conferimento da parte dell'interessato dei dati richiesti ha carattere
                            obbligatorio;
                        </li>
                        <li>che l'eventuale rifiuto da parte dell'interessato di conferire i dati richiesti renderà
                            impossibile portare a termine la sua richiesta;
                        </li>
                        <li>che i dati raccolti saranno comunicati agli uffici preposti per l'espletamento delle
                            specifiche formalità di legge nelle forme e nei limiti previsti dalla legge;
                        </li>
                        <li>che i dati raccolti saranno di volta in volta aggiornati e dagli stessi non sarà data
                            diffusione o comunicazione diversa da quelle sopra indicate;
                        </li>
                        <li>che l'interessato può far valere i diritti previsti dall'art. 7 del D. Lgs. 196/2003 (vedi
                            in fondo alla pagina);
                        </li>
                        <li>che il responsabile delle operazioni di trattamento dei dati, presso il titolare, è il
                            Presidente pro tempore del Registro Fiat Italiano, a cui l'interessato può rivolgersi per
                            far valere i propri diritti di accesso alla banca dati.
                        </li>
                    </ol>
                    <p>Preso atto di quanto sopra il sottoscritto richiedente, esprime il
                        proprio <strong>CONSENSO</strong> i sensi dell'art. 23 del D. Lgs. 196/2003 al trattamento dei
                        propri dati personali.</p>
                </div>
                <Formik
                    initialValues={{
                        privacy_cert: '0'
                    }}
                    innerRef={formikRef}
                    onSubmit={values => {
                        aggiornaPrivacyCertificato(values);
                    }}
                >
                    {({errors, touched, values, submitCount}) => (
                        <Form>
                            <div className="col-md-12 mb-4">
                                <div className="rfi-va--center rfi-display--flex">
                                    <Field
                                        type="checkbox"
                                        name={"privacy_cert"}
                                        className="form-check-input"
                                        checked={values['privacy_cert'] == '1'}
                                        onChange={e => {
                                            formikRef.current.setFieldValue('privacy_cert', e.target.checked ? '1' : '0')
                                        }}
                                        validate={(value) => {
                                            if (value != '1' && !isRuoloAdmin() && !isRuoloSegreteria()) {
                                                return 'È necessario accettare l\'informativa'
                                            }
                                        }}
                                    />
                                    &nbsp;
                                    &nbsp;
                                    <label htmlFor={"privacy_cert"} className="form-label">Accetto</label>
                                </div>
                                <LabelErroreCampo errors={errors} touched={touched} name={"privacy_cert"}
                                                  submitCount={submitCount}/>
                            </div>
                        </Form>
                    )}
                </Formik>
                <div className={"mt-4"}>
                    <p><strong>Art. 7 - D. Lgs. 30/06/2003 n° 196: "Diritti dell'interessato"</strong></p>
                    <ol type={"1"}>
                        <li>
                            In relazione al trattamento dei dati personali, l'interessato ha diritto:
                            <ol type={"a"}>
                                <li>di conoscere, mediante accesso gratuito al registro di cui all'art. 31, comma 1,
                                    lettera a), l'esistenza di trattamenti di dati che possono riguardarlo;
                                </li>
                                <li>di essere informato su quanto indicato all'art. 7, comma 4, lettere a), b) ed h);
                                </li>
                                <li>
                                    di ottenere, a cura del titolare o del responsabile, senza ritardo:
                                    <ol type={"1"}>
                                        <li>la conferma dell'esistenza o meno di dati personali che lo riguardano, anche
                                            se non ancora registrati e la comunicazione in forma intelligibile dei
                                            medesimi dati e della loro origine, nonché della logica e della finalità su
                                            cui si basa il trattamento; la richiesta può essere rinnovata, salva
                                            l'esistenza di giustificati motivi, con intervallo non minore di novanta
                                            giorni;
                                        </li>
                                        <li>la cancellazione, la trasformazione in forma anonima o il blocco dei dati
                                            trattati in violazione di legge, compresi quelli di cui non è necessaria la
                                            conservazione in relazione agli scopi per i quali i dati sono stati raccolti
                                            o successivamente trattati;
                                        </li>
                                        <li>l'aggiornamento, la rettificazione ovvero, qualora vi abbia interesse,
                                            l'integrazione dei dati;
                                        </li>
                                        <li>l'attestazione che le operazioni di cui ai numeri 2) e 3) sono state portate
                                            a conoscenza, anche per quanto riguarda il loro contenuto, di coloro ai
                                            quali i dati sono stati comunicati o diffusi, eccettuato il caso in cui tale
                                            adempimento si riveli impossibile o comporti un impiego di mezzi
                                            manifestamente proporzionato rispetto al diritto tutelato;
                                        </li>
                                    </ol>
                                </li>
                                <li>di opporsi, in tutto o in parte, per motivi legittimi, al trattamento di dati
                                    personali che lo riguardano, ancorché pertinenti allo scopo della raccolta;
                                </li>
                                <li>di opporsi, in tutto o in parte, al trattamento di dati personali che lo
                                    riguardano, previsto ai fini di informazione commerciale o di invio di materiale
                                    pubblicitario o di vendita diretta ovvero peri l compimento di ricerche di mercato o
                                    di comunicazione commerciali interattive e di essere informato dal titolare, non
                                    oltre il momento in cui i dati sono comunicati o diffusi, delle possibilità di
                                    esercitare gratuitamente tale diritto;
                                </li>
                            </ol>
                        </li>
                        <li>Per ciascuna richiesta di cui al comma 1, lettera c), numero 1), può essere chiesto
                            all'interessato, ove non risulti confermata l'esistenza di dati che lo riguardano, un
                            contributo spese, non superiore ai costi effettivamente sopportati, secondo le modalità ed
                            entro limiti stabiliti dal regolamento di cui all'art. 33, comma 3.
                        </li>
                        <li>I diritti di cui al comma 1, riferiti ai dati personali concernenti persone decedute possono
                            essere esercitati da chiunque vi abbia interesse.
                        </li>
                        <li>Nell'esercizio dei diritti di cui al comma 1 l'interessato può conferire, per iscritto,
                            delega o procura a persone fisiche o ad associazioni.
                        </li>
                        <li>Restano ferme le norme sul segreto professionale degli esercenti la professione di
                            giornalista, limitatamente alla fonte della notizia.
                        </li>
                    </ol>
                </div>
            </div>
        </Card>
    );
}